import * as mobx from 'mobx';
import { SHORT_PLAIN_TEXT_LENGTH } from '../../constans/common-constants';
import { PollChoiceStatus } from '../../constans/polls-constants';

export interface IResponseItem {
  pollId: string;
  pollChoiceId: string;
  value: string;
  order: number;
  status: PollChoiceStatus;
  isCustomResponse?: boolean;
  count?: number;
}

class ResponseEntity implements IResponseItem {
  public pollId: string;
  public pollChoiceId: string;
  public value: string;
  public order: number;
  public status: PollChoiceStatus;
  public isCustomResponse?: boolean;
  public count?: number;

  constructor (fromDTO: IResponseItem) {
    mobx.makeAutoObservable(this);
    this.deserialize(fromDTO);
    this.isCustomResponse = false;
  }

  public setValue = (value: string): void => {
    this.value = value;
  };

  public setStatus = (value: PollChoiceStatus): void => {
    this.status = value;
  };

  public checkIsResponseValid = (): boolean => {
    return this.value.trim().length > 0 && this.value.length <= SHORT_PLAIN_TEXT_LENGTH;
  };

  public serialize (): IResponseItem {
    return {
      pollId: this.pollId,
      pollChoiceId: this.pollChoiceId,
      value: this.value,
      order: this.order,
      status: this.status,
      isCustomResponse: this.isCustomResponse,
    };
  }

  private deserialize (fromDTO: IResponseItem): void {
    this.pollId = fromDTO.pollId;
    this.pollChoiceId = fromDTO.pollChoiceId;
    this.value = fromDTO.value;
    this.order = fromDTO.order;
    this.status = fromDTO.status || PollChoiceStatus.ACTIVE;
    this.isCustomResponse = fromDTO.isCustomResponse || false;
    this.count = fromDTO.count || 0;
  }
}

export default ResponseEntity;
